import { StarIcon } from 'lucide-react';
import { fetchInsightsBusiness } from '../../adminApi';
import { Panel } from '../../ui/Panel';
import { dayShort } from '../../../core/format/dates';
import { Kpi } from '../Kpi';
import { ReportView } from '../ReportView';
import { useReport } from '../useReport';
import { fmt } from '../insightFormat';
import type { PeriodState } from '../../sales/usePeriodParams';

/** Google Bedrijfsprofiel: gevonden in Zoeken en Maps, wat mensen daarna doen, en reviews. */
export function BusinessBlock({
  period
}: {
  period: PeriodState;
}) {
  const report = useReport(fetchInsightsBusiness, period.from, period.to);
  return <ReportView report={report} what="De cijfers van het Bedrijfsprofiel" integration="googleBusiness" data-id="element-1862" data-mp="2bbz4zmnakzdk">
      {b => <div className="grid gap-6 lg:grid-cols-[minmax(0,1.4fr)_minmax(0,1fr)]" data-id="element-1863" data-mp="26gaahxq4q8o4">
          <Panel title="Bedrijfsprofiel" description="Hoe vaak de salon in Google verscheen, en wat mensen daarna deden" data-id="element-1864" data-mp="2lbzmr45ij7fn">
            <dl className="grid grid-cols-2 gap-x-5 gap-y-5 sm:grid-cols-3" data-id="element-1865" data-mp="2gak39gizh8zd">
              <Kpi label="Getoond in Zoeken" value={b.views.search} data-id="element-1866" data-mp="2wmk3lbmtz13l" />
              <Kpi label="Getoond in Maps" value={b.views.maps} data-id="element-1867" data-mp="31l3nl6hv62tb" />
              <Kpi label="Route gevraagd" value={b.actions.route} data-id="element-1868" data-mp="35lnl4b6cn8fz" />
              <Kpi label="Gebeld" value={b.actions.call} data-id="element-1869" data-mp="35kchcbcwm0ov" />
              <Kpi label="Naar de website" value={b.actions.website} data-id="element-1870" data-mp="3al0fri3gpjt4" />
            </dl>
          </Panel>
          <Panel title="Reviews" description={b.reviews.count ? `${b.reviews.count} reviews, gemiddeld ${fmt(b.reviews.average, 'decimal')}` : undefined} data-id="element-1871" data-mp="3fis98gjr9dzf">
            {b.reviews.latest.length === 0 ? <p className="text-[13px] text-muted" data-id="element-1872" data-mp="3papmrty8ki1b">Nog geen reviews.</p> : <ul className="space-y-4" data-id="element-1873" data-mp="3tbhz4w2en31t">
                {b.reviews.latest.map(r => <li key={`${r.author}-${r.date}`} className="text-[13px]" data-id="element-1874" data-mp="25q7fs8zbicw">
                    <p className="flex items-center gap-2 text-ink" data-id="element-1875" data-mp="73s2lbjoj84q">
                      {r.author}
                      <span className="inline-flex items-center gap-0.5 text-clay" aria-label={`${r.rating} van 5 sterren`} data-id="element-1876" data-mp="236wrajfenab2">
                        {Array.from({
                  length: 5
                }, (_, i) => <StarIcon key={i} className={`h-3 w-3 ${i < r.rating ? 'fill-current' : 'opacity-30'}`} strokeWidth={1.5} aria-hidden="true" data-id="element-1877" data-mp="2cwzjwiim6m8v" />)}
                      </span>
                      <span className="text-muted" data-id="element-1878" data-mp="2lxe7xpmyqfg2">{dayShort(r.date)}</span>
                    </p>
                    <p className="mt-1 leading-relaxed text-muted" data-id="element-1879" data-mp="2hwcfpsrgr3nl">{r.text}</p>
                  </li>)}
              </ul>}
            <p className="mt-4 text-[12px] text-muted" data-id="element-1880" data-mp="2vvbum8p6c46k">Beantwoorden doe je in Google.</p>
          </Panel>
        </div>}
    </ReportView>;
}